/*
* PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
* Copyright (c) 2017 Pearson Education, Inc.
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains the property of
* Pearson Education, Inc. The intellectual and technical concepts contained
* herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
* and Foreign Patents, patent applications, and are protected by trade secret
* or copyright law. Dissemination of this information, reproduction of this
* material, and copying or distribution of this software is strictly forbidden
* unless prior written permission is obtained from Pearson Education, Inc.
*/
import React from 'react'
import { FormattedDate, FormattedMessage, IntlProvider } from 'react-intl'
import { number, string } from 'prop-types'
import messages from '../messages'
import Icon from '../Icon'
import './courseListingHeader.scss'

const CourseListingHeader = ({ startDate, endDate, courseCode, courseName }) => {
  return (
    <IntlProvider locale='en' message={messages}>
      <div className='sub-container course-listing-header'>
        <div className='course-listing'>
          <div className='text-container'>
            <div className='course-subtitle-container'>
              <p className='pe-copy no-margin margin-right'><b>{courseName}: </b>{courseCode}&nbsp;</p>
              <p className='pe-copy no-margin margin-left'>
                <FormattedDate value={new Date(startDate)} year='numeric' month='short' day='numeric' />
              	&nbsp;-&nbsp;
                <FormattedDate value={new Date(endDate)} year='numeric' month='short' day='numeric' />
              </p>
            </div>
          </div>
          <div className='settings'>
            <button type='button' className='pe-proto pe-btn--link course-settings-link'>
              <Icon fileName='settings-18' title='Course Settings' />
                &nbsp;
              <FormattedMessage
                id='messages.courseSettings'
                description='Course Settings'
                defaultMessage='Course Settings'
                  />
            </button>
          </div>
        </div>
      </div>
    </IntlProvider>
  )
}

CourseListingHeader.propTypes = {
  startDate: number,
  endDate: number,
  courseCode: string,
  courseName: string
}

export default CourseListingHeader
